<div style="padding: 1em">
  <h2 style="padding: 0; margin: 0">{{ title }}</h2>
  <div class="content">{{ description }}</div>
  <app-button-box style="width: 100%; text-align: center">
    <button mat-raised-button color="primary" (click)="close(false)">Nei</button>
    <button mat-raised-button color="warn" (click)="close(true)">Ja</button>
  </app-button-box>
</div>

